import { Directive, ElementRef, HostListener } from "@angular/core";

// Mantém o cursor no fim do campo ao focar/tocar. Usado com `currencyMask` (ngx-currency),
// que insere o dígito na posição do cursor: tocar no meio de "R$ 0,00" e digitar "1000"
// resultava em "R$ 100,00" em vez de "R$ 10,00".
@Directive({
    selector: "input[appCaretAtEnd]",
})
export class CaretAtEndDirective {
    constructor(private elementRef: ElementRef<HTMLInputElement>) {}

    @HostListener("focus")
    @HostListener("click")
    @HostListener("mouseup")
    @HostListener("touchend")
    moveCaretToEnd(): void {
        setTimeout(() => {
            const input = this.elementRef.nativeElement;
            if (document.activeElement !== input || input.selectionStart !== input.selectionEnd) {
                return;
            }
            const end = input.value.length;
            input.setSelectionRange(end, end);
        });
    }
}
